import React from 'react';

import {ClipboardButton, ClipboardButtonProps} from '@gravity-ui/uikit';

import {block} from '../../utils/cn';

import './ClipboardButtonWrapper.scss';

const b = block('clipboard-button-wrapper');

export interface ClipboardButtonWrapperProps extends Omit<ClipboardButtonProps, 'text'> {
    text?: ClipboardButtonProps['text'];
    className?: string;
    children?: React.ReactNode;
}

const DEFAULT_ICON_SIZE = 14;

export const ClipboardButtonWrapper: React.FunctionComponent<ClipboardButtonWrapperProps> = (
    props,
) => {
    const {text, size = DEFAULT_ICON_SIZE, children, className} = props;
    return (
        <span className={b(null, className)}>
            <span className={b('container')}>
                {children}
                {text && (
                    <span className={b('clipboard-button')}>
                        <ClipboardButton text={text} size={size} />
                    </span>
                )}
            </span>
        </span>
    );
};
